import { Link } from "react-router-dom";

const StaffTabBar = ({ activeTab,useTab,UserName }) => {
  const tabs = [
    { id: "updateInfo", label: "Update Info", link: `/staff/UpdateStaff/${UserName}` },
    { id: "updatePassword", label: "Update Password", link: `/staff/updatePassword/${UserName}` },
    // { id: "weeklySchedule", label: "Weekly Schedule", link: `/staff/weeklySchedule/${UserName}` },
  ];


  return (
    <ul className="nav nav-tabs nav-tabs-v2 px-3">
      {tabs.map((tab) => (
        <li className="nav-item me-2" key={tab.id}>
          <Link
            to={tab.link}
            className={`nav-link px-2 ${activeTab === tab.id ? "active" : ""}`}
            {...(useTab === true ? { "data-bs-toggle": "tab" } : {})}
          >
            {tab.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default StaffTabBar;
